import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedAnticiposDialogoComponent {
  importe = undefined
  onClose
  viaticoId = null

  solicitar () {
    this.onClose({$event: {detail: this.importe}})
  }

  cerrar () {
    this.onClose({$event: {detail: null}})
  }
}

module.component('viaticosSharedAnticiposDialogo', {
  controller: ViaticosSharedAnticiposDialogoComponent,
  template,
  bindings: {
    viaticoId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/anticipos/dialogo/component.js